export const CRYPTO_SERVICE = "CryptoService";
